import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { Address } from '../types'

type AddressesListSelector = (state: ReduxState) => Address[]
const getAddressesList: AddressesListSelector = state => Object.values(state.addresses.addresses)

export const addressesListSelector: AddressesListSelector = createSelector(getAddressesList, list => list)
